import React from "react";

interface ResizeHandleProps {
  isResizing: boolean;
  onMouseDown: (e: React.MouseEvent) => void;
}

/**
 * A draggable resize handle for adjusting panel widths.
 * Provides visual feedback during resize operations.
 */
export const ResizeHandle: React.FC<ResizeHandleProps> = ({ isResizing, onMouseDown }) => {
  return (
    <div
      className="relative cursor-col-resize flex items-center justify-center"
      data-testid="resize-handle"
      onMouseDown={onMouseDown}
    >
      {/* Thin vertical line - matches the left divider style */}
      <div className={`w-px h-full bg-divider ${isResizing ? "bg-default-300" : ""}`} />
      {/* Grab handle - centred button with grip lines */}
      <div
        className={`absolute flex flex-col gap-0.5 px-1.5 py-2 rounded transition-colors ${isResizing ? "bg-default-200" : "bg-default-100 hover:bg-default-200"}`}
      >
        <div className="w-1 h-px bg-default-400" />
        <div className="w-1 h-px bg-default-400" />
        <div className="w-1 h-px bg-default-400" />
      </div>
    </div>
  );
};
